export default class VuInSe {
    public vueinstance!: Vue;
}
export const VueInstanceService = new VuInSe();
